import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DoctorVisitChooserComponent } from './doctor-visit-chooser.component';
import { FormComponentsModule } from '../form-components/form-components.module';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [DoctorVisitChooserComponent],
  exports: [DoctorVisitChooserComponent],
  imports: [
    CommonModule,
    FormComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    SharedModule,
    MatTooltipModule,
  ],
})
export class DoctorVisitChooserModule {}
